import { render, staticRenderFns } from "./ProductCertificationBadge.vue?vue&type=template&id=7adfb08e&scoped=true"
import script from "./ProductCertificationBadge.vue?vue&type=script&lang=js"
export * from "./ProductCertificationBadge.vue?vue&type=script&lang=js"
import style0 from "./ProductCertificationBadge.vue?vue&type=style&index=0&id=7adfb08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adfb08e",
  null
  
)

export default component.exports